/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")
  

// 接口文档

  
    
export interface IAPI77354ReqOrderObjectsItem {
  
  /**  */
  orderByColumn?: string;
  
  /**  */
  orderByDesc?: boolean;
  
};
    
  
    
export interface IAPI77354ResListItem {
  
  /**  */
  id?: number;
  
  /** 插件名称 */
  name?: string;
  
  /** 插件编码 */
  code?: string;
  
  /** 插件描述 */
  description?: string;
  
  /** 插件类型:默认Rest接口 */
  pluginType?: string;
  
  /** 插件执行数据 */
  pluginData?: string;
  
  /** 扩展数据类型:默认chatGPT */
  extType?: string;
  
  /** 扩展数据:存储私有信息 */
  ext?: string;
  
  /**  */
  createdAt?: any;
  
  /**  */
  updatedAt?: any;
  
  /**  */
  isDeleted?: number;
  
};
    
  



export interface API77354Req {
  
  /**  */
  name?: string;
  /**  */
  pageSize?: number;
  /**  */
  pageIndex?: number;
  /**  */
  rowId?: string;
  /**  */
  jumpType?: number;
  /**  */
  searchCount?: boolean;
  /** OrderByColumn */
  orderObjects?: IAPI77354ReqOrderObjectsItem[];
};



export interface API77354Res {
  /** T  */
  list?: IAPI77354ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 77354 插件分页列表

export interface IUsePostAPI77354Return {
  /** 插件分页列表: 接口请求状态 */
  isAPI77354Loading: boolean;
  /** 插件分页列表: 接口请求返回数据 */
  dataAPI77354: API77354Res;
  /**  插件分页列表: 接口数据请求方法 */
  fetchAPI77354Data: (inputs: API77354Req, config?: YWRequestConfig) => Promise<API77354Res>;
  /** 插件分页列表: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77354 = ():IUsePostAPI77354Return => {
  let isMount = true;
  const [isAPI77354Loading, setIsAPI77354Loading] = useState(false);
  const [dataAPI77354, setDataAPI77354] = useState<API77354Res>({} as API77354Res);
  const requestUrl = `${basePath}/yoaichat-admin/plugin/library/page`;

  const fetchAPI77354Data = async (inputs: API77354Req, config?: YWRequestConfig): Promise<API77354Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API77354Req>) || {}) as API77354Req;
    
  
    if ( isMount ) {
      setIsAPI77354Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API77354Res>(`${basePath}/yoaichat-admin/plugin/library/page`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI77354(res || {} as API77354Res);
        setIsAPI77354Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI77354Loading(false);
      }
      return false as unknown as API77354Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77354Loading,
    dataAPI77354,
    fetchAPI77354Data,
    requestUrl,
  }
}

